/**
 * A one character code identifying whether the Fund based renewal commission is to be waived.
 * tag: 497
 * @readonly
 * @enum {string} (char)
 */
export enum FundRenewWaiv {
  /** No */
  No = 'N',
  /** Yes */
  Yes = 'Y',
}
